import React from 'react';
import { connect } from 'react-redux';
import {
    closeNavBar,
    contentLoaded, postExamResult, setAnimView, setItemView
} from "../../actions";
import { bindActionCreators } from "redux";
import $ from "jquery";
import '../../UI/Modal/Modal';
import Modal from "../../UI/Modal/Modal";
import Logo from "../logo/Logo";
import './FrameContent.css';

class FrameContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            showModal: false,
            iframeUrl: '',
            videoLoaded: false,
            scrolled: false,
            showLoading: true,
            newTag: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.link !== prevProps.link) {
            this.setState({ showLoading: true });
            this.setState({ scrolled: false });
        }
    }

    componentDidMount() {
    }

    render() {
        let link = this.props.link.length > 0 ? this.props.link : "no_file";
        let item = this.props.chapterContent.bookContent.filter(chapter => chapter.key === link)[0];
        return (
            <div>
                {item ?
                    this.frameLoaded(item.content)
                    : <Logo show={!this.state.showLoading} />}
            </div>
        );
    }

    frameLoaded = item => {
        if (item.includes("homescreen on Android") || item.length < 1) {
            this.props.onLoader();
            return (<p style={{
                paddingTop: '25%',
                textAlign: 'center',
                fontWeight: "bold",
            }}>Файл ещё не загружен</p>)
        }

        return (
            <div className="scroll-wrapper">
                <iframe
                    id="thisIsIframe"
                    style={{
                        width: '100%',
                        overflowX: 'hidden',
                        height: '100%',
                        minHeight: this.props.task ? '150px' : 'unset',
                        maxHeight: this.props.task ? '550px' : 'unset',
                        display: !this.state.showLoading ? 'block' : 'none',
                    }}
                    onLoad={() => {
                        this.fromIframe();
                        this.props.onLoader();
                        if(this.props.task) {
                            setTimeout(function(){
                                var obj = document.getElementById('thisIsIframe');
                                obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
                            }, 500)
                        }
                    }
                    }
                    srcDoc={item}
                />
                <Logo
                    show={!this.state.showLoading}
                />
                {this.renderModal()}
            </div>
        )
    };

    renderModal = () => {
        if (this.state.showModal && this.state.iframeUrl && this.props.link.length > 0) {
            let newLink = this.props.link.substr(0, this.props.link.length - 10);
            let dividedUrl = this.state.iframeUrl.split("/");
            let urlAddress;
            console.log("url", this.state.iframeUrl, newLink, dividedUrl);
            if (!this.state.newTag) {
                if (this.state.iframeUrl.includes("modal:nodes/")) {
                    urlAddress = newLink + dividedUrl[dividedUrl.length - 2] + "/" + dividedUrl[dividedUrl.length - 1];
                    // console.log("animaiton 1", urlAddress);
                } else {
                    let link = this.props.link.split('/');
                    let newLink = link.splice(0, link.length - 3);
                    urlAddress = newLink.join("/") + "/common/" + this.state.iframeUrl.split(':').splice(1, 1).join("");
                    // console.log("animation 2", urlAddress);
                }
            } else {
                urlAddress = this.state.iframeUrl;
            }
            let top = parseInt(this.props.window.height) / 8;
            console.log('ANIMACIA', this.state.animId)
            this.props.onAnimView({
                animation_id: this.state.animId
            })
            return (
                <div>
                    <Modal
                        top={top}
                        link={"https://mbook.kz" + urlAddress}
                        onCloseModal={this.onCloseModal}
                    />
                </div>
            )
        }

        return null;
    };

    onCloseModal = () => {
        this.setState({ showModal: false })
    };

    fromIframe = () => {
        this.setState({ showLoading: false });
        let iframe = $('#thisIsIframe').contents();
        let frameContent = document.getElementById('thisIsIframe').contentWindow.document.getElementsByTagName('body')[0];
        let buttons = frameContent.getElementsByClassName('btn-group');
        for (let button of buttons) {
            let options = button.getElementsByClassName('dropdown-menu');
            options[0].style.cssText = "border:1px solid red";
        }
        document.getElementById('thisIsIframe').contentDocument.addEventListener('click', event => {
            event.preventDefault();
            this.props.closeNavBar()
        });
        if (!this.state.scrolled) {
            this.setState({ scrolled: true });
            let link = this.props.link.length > 0 ? this.props.link : "no_file";
            let item = this.props.chapterContent.bookContent.filter(chapter => chapter.key === link)[0];
            this.props.onItemView({
                courseID: item.itemViewLink[0],
                nodeID: item.itemViewLink[1],
                itemID: item.itemViewLink[2]
            })
        }
        let anime = frameContent.getElementsByTagName("AN");
        let animeLength = anime.length;
        // console.log("Anime tag", anime);

        for (let i = 0; i < animeLength; i++) {
            let frameAnime = document.createElement('iframe');
            let lang = this.props.chapters.chaptersList[0].book_lang;
            let animId = anime[0].id
            frameAnime.src = `/restapp/get_animation/${animId}/?lang=${lang}`;
            frameAnime.id = "anime" + animId;
            // frameAnime.className = "anime";
            frameAnime.style.cssText = "margin:auto; display: block; width: 550px; height: 350px";
            frameAnime.onload = frameAnime => this.animeFrameLoaded(frameAnime, animId);
            anime[0].parentNode.replaceChild(frameAnime, anime[0]);
        }
        //
        // console.log("This is anime tag", frameContent.getElementsByTagName("AN"));
        // let anime = frameContent.getElementsByTagName("AN");
        // console.log("anime", anime);
        // for (let i = 0; i < anime.length; i++) {
        //     let newAnime = document.createElement('iframe');
        //     newAnime.src = `https://mbook.kz/restapp/get_animation/${anime[i].id}/`;
        //     newAnime.classList.add('an');
        //     anime[i].parentNode.replaceChild(newAnime, anime[i]);
        // }

        // TODO UNCOMMENT
        // iframe.scroll((e) => {
        //     if (!this.state.scrolled) {
        //         this.setState({scrolled: true});
        //         let link = this.props.link.length > 0 ? this.props.link : "no_file";
        //         let item = this.props.chapterContent.bookContent.filter(chapter => chapter.key === link)[0];
        //         this.props.onItemView({
        //             courseID: item.itemViewLink[0],
        //             nodeID: item.itemViewLink[1],
        //             itemID: item.itemViewLink[2]
        //         })
        //     }
        // });
        // TODO UNCOMMENT

        // let element = $('.box').css('border', '1px solid red !important');
        // iframe.find('a.list-group-item').click((e) => {
        //     e.preventDefault();
        // });
        // COMMENTED FROM HERE
        iframe.find('a').each(function (i, obj) {
            if (obj.getAttribute('href') === '#') {
                // obj.click(event => event.preventDefault());
            }
            // if(obj.getAttribute('href'))
        });
        // iframe.find('.box').removeAttr('style').css("fontSize", "14px");
        iframe.find('a.list-group-item').css("fontSize", "14px");

        iframe.find('a.list-group-item').click((e) => {
            e.preventDefault();
        });
        let dontGlue = iframe.find('style10.css');
        if (!dontGlue) {
            iframe.find('span').css('margin', '-3px');
        }
        iframe.find('sub').css('marginLeft', "-0.5em");

        iframe.find('a.glyphicon.glyphicon-play').css("top", "-0.5em");
        iframe.find('div.box.inner').css("left", "50%");
        iframe.find('div.box.inner').css("top", "50%");
        iframe.find('#step01Ans').click(e => {
            e.preventDefault();
            this.sendMark(iframe, frameContent);
            // alert("ans button clicked");
        });
        iframe.find('#step02Ans').click(e => {
            e.preventDefault();
            this.sendMark(iframe, frameContent);
        });
        iframe.find('button#answer').click(e => {
            e.preventDefault();
            this.sendMark(iframe, frameContent);
        });
        iframe.find('a.glyphicon.glyphicon-play').click((e) => {
            e.preventDefault();
            this.setState({ showModal: true });
            let ifrmeUrl = $(e.target).attr('href');
            console.log("Modal href", ifrmeUrl);
            this.setState({ iframeUrl: ifrmeUrl });
        });

        // iframe.find('.box.inner').click((e) => {
        //     e.preventDefault();
        //     // this.setState({showModal: true});
        //     // let ifrmeUrl = $(e.target).attr('href');
        //     // this.setState({iframeUrl: ifrmeUrl});
        // });

    };
    // TODO UNCOMMENT
    animeFrameLoaded = (frame, animId) => {
        let path = frame.path || (frame.composedPath && frame.composedPath());
        if (path) {
            path[0].contentDocument.all[path[0].contentDocument.all.length - 1].addEventListener('click', e => {
                e.preventDefault();
                // console.log("button clicked", frame.path[0].contentDocument.all[frame.path[0].contentDocument.all.length-1].getAttribute('href'));
                this.setState({ newTag: true });
                this.setState({ showModal: true });
                // let ifrmeUrl = $(e.target).attr('href');
                let ifrmeUrl = path[0].contentDocument.all[path[0].contentDocument.all.length - 1].getAttribute('href').split("modal:");
                // console.log("Modal href", ifrmeUrl);
                this.setState({ iframeUrl: ifrmeUrl[1], animId: animId});
            })
        }

    };
    // TODO UNCOMMENT END


    sendMark = (iframe, frameContent) => {
        iframe.find("span#markSend").css("display", "none");
        iframe.find("fieldset#mark").css('display', 'block');
        let allLinks = frameContent.querySelectorAll('a');
        let solutionMark = 0;
        for (let i = 0; i < allLinks.length; i++) {
            if (allLinks[i].getAttribute('href').includes('problem')) {
                solutionMark = parseInt(allLinks[i].getAttribute('href').split(":")[1]);
            }
        }
        // let studentMark = frameContent.querySelector("a").getAttribute("href").split(":");
        if (solutionMark > 100) {
            solutionMark = 100;
        }
        let data = {
            course_id: this.props.active_item.courseId,
            item_id: this.props.active_item.item_id,
            result: solutionMark
        };
        this.props.onResultPost(data);
    }

}

const
    mapStateToProps = state => ({
        loaded: state.loaded,
        active_item: state.active_item,
        chapterContent: state.chapterContent,
        window: state.window,
        chapters: state.chapters,
    });

function

    mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            onContentLoaded: contentLoaded,
            onItemView: setItemView,
            onAnimView: setAnimView,
            onResultPost: postExamResult,
            closeNavBar: closeNavBar,
        }, dispatch
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(FrameContent);



// WEBPACK FOOTER //
// ./src/components/frame/FrameContent.js